import { useEffect, useState } from 'react'
import { CustomCellEditorProps } from 'ag-grid-react'
import { CustomEnumValue } from '../../../../../lib/commons/appFunction'
import { StatusComboBox } from '../ComboBox/StatusComboBox'
import { filterValuesByCombination } from '../../../../../lib/commons/customEnum'
import objects from '../../../../../utils/objects'
import { ProgressIcon } from '../../../../containers/commons/AgGrid/components/cell/custom/wbsItemStatus/ProgressIcon'
import {
  ProjectPlanNewStatusRootDiv,
  ProgressIconArea,
} from '../CellRenderer/ProjectPlanNewStatusCellRenderer'
import usePrevious from '../../../../hooks/usePrevious'

interface Props extends CustomCellEditorProps {
  customEnumCode?: string
  combinedValuePath?: (combinedEnumCode: string) => string
  valuesAllowed?: CustomEnumValue[]
  popperOpen?: boolean
}

export const ProjectPlanNewStatusCellEditor = ({
  customEnumCode,
  combinedValuePath,
  value,
  api,
  context,
  data,
  onValueChange,
}: Props) => {
  const [val, setVal] = useState(value ?? '')
  const wbsItem = data?.body?.wbsItem ?? data?.wbsItem

  let options: CustomEnumValue[] = []
  if (customEnumCode) {
    options = filterValuesByCombination(context[customEnumCode], code =>
      objects.getValue(data, combinedValuePath?.(code))
    )
  }

  const prevVal = usePrevious(val)
  useEffect(() => {
    if (val && prevVal && val !== prevVal) {
      api.stopEditing()
    }
  }, [api, val, prevVal])

  if (!options) return <></>

  return (
    <ProjectPlanNewStatusRootDiv>
      <ProgressIconArea>
        <ProgressIcon wbsItem={wbsItem} fontSize={20} />
      </ProgressIconArea>
      <StatusComboBox
        value={val}
        options={options}
        dropDownListOpen={true}
        onChange={newValue => {
          onValueChange(newValue)
          setVal(newValue)
        }}
        onClick={() => {
          api.stopEditing()
        }}
      />
    </ProjectPlanNewStatusRootDiv>
  )
}
